<template>
  <svg class="icon" width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.640625 0V14H14.6406V0H0.640625ZM13.8171 8.23525H5.17026V9.05872H13.8171V13.1762H5.99376V11.1174H5.17029V13.1762H1.46441V9.05872H3.11149V8.23525H1.46441V0.823498H5.58191V4.94099H3.52311V5.76446H11.7584V4.94099H6.40548V0.823498H13.8172L13.8171 8.23525Z" fill="#0C4897"/>
  </svg>
</template>